import {
    PROFILE_ERROR,
    PROFILE_SUCCESS,
    EDIT_PROFILE,
    SET_PROFILE,
    SET_PROFILE_SUCCESS,
} from './actionTypes';

const initialState = {
    error: "",
    success: "",
    user: null,
    employee: null,
    company: null,
    role: null,
    permissions: null,
    isManaging: null,
};

const profile = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_PROFILE:
            state = { ...state };
            break;
        case PROFILE_SUCCESS:
            state = { ...state, success: action.payload };
            break;
        case PROFILE_ERROR:
            state = { ...state, error: action.payload };
            break;
        case SET_PROFILE:
            state = { ...state };
            break;
        case SET_PROFILE_SUCCESS:
            state = {
                ...state,
                user: action.payload.user,
                company: action.payload.company,
                employee: action.payload.employee,
                role: action.payload.role,
                permissions: action.payload.permissions,
                isManaging: action.payload.isManaging,
                managerRole: action.payload.managerRole,
            };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default profile;